import { Injectable } from '@angular/core';
import { CodedEntity } from '@asm/features/sync/models/coded-entity.model';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';

/** Store: `country_origins` | keyPath: `code` */
@Injectable({ providedIn: 'root' })
export class CountryOriginRepository extends RepositoryBase<CodedEntity> {
  protected readonly KEY_PATH = 'country_origins';
}
